import { AdministrativeProvider } from './administrativePanelContext'
import { AdmPanelContent } from './admPanelContent'

export function AdministrativePanel() {
  return(
    <AdministrativeProvider>
        <AdmPanelContent />
    </AdministrativeProvider>
  )
}

